import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  change,
  Field,
  getFormValues,
  InjectedFormProps,
  reduxForm,
  reset,
} from "redux-form";
import { FormattedMessage } from "react-intl";
import filterMessages from "./module/messages";

import { Box, MenuItem } from "@mui/material";

// Import styles
import classes from "./Filter.module.scss";
import modelSchema from "../../module/form/modelSchema";
import TextInputFieldUI from "../../components/TextInputField/TextInputField";
import DateRangePicker from "../../components/ResponsiveDateRangePicker/ResponsiveDateRangePicker";
import SelectFieldUI from "../../components/SelectField/SelectField";
import ToggleField from "../../components/ToggleField/ToggleButton";
import OutlinedButton from "../../ui/OutlinedButton/OutlinedButton";
import {
  DATA_RANGE_PICKER,
  SELECT_FIELD,
  TOGGLE_FIELD,
} from "./module/constants";
import { isNil } from "ramda";
import { generalConst } from "../../module/globalInterface";

export interface IFilterProps {
  formProps: string;
  onSubmitProps: Function;
  formValues: any;
  messages: any;
  resetForm: Function;
  changeForm: (field: string, value: any) => {};
  listsFilter?: any;
  showHideFilter: Function;
  advancedFilter?: boolean;
  noCta?: boolean;
  fullColored?: boolean;
  initialFilterValue?: any;
  initialFilterState?: any;
  setOnChange: (values: any) => {};
  columnOrder?: string[];
  customHideColumns?: generalConst;
  allowAdvancedFilter: boolean;
}

const submitting = (e: any, handleSubmit: any) => {
  e.preventDefault();
  handleSubmit();
};

const components = {
  TextInputFieldUI: TextInputFieldUI,
  DateRangePicker: DateRangePicker,
  ToggleField: ToggleField,
  SelectFieldUI: SelectFieldUI,
};

let form: string = "initFilterState2";
let formModel: any = {};
let onSubmit: any = (_values: any, _dispatch: any, _props: any) => {};

const Filter2: React.FC<IFilterProps & InjectedFormProps<{}, IFilterProps>> = (
  props: any
) => {
  const {
    formProps,
    onSubmitProps,
    handleSubmit,
    changeForm,
    formValues,
    messages,
    listsFilter,
    resetForm,
    advancedFilter,
    noCta = false,
    fullColored,
    setOnChange,
    dispatch,
    initialFilterValue,
    initialFilterState,
    columnOrder = [],
    customHideColumns = {},
    allowAdvancedFilter,
  } = props;
  form = formProps;

  formModel = modelSchema[formProps as keyof typeof modelSchema];

  // remove from filter
  let keysToRemove = Object.values(customHideColumns);
  keysToRemove.forEach((key) => {
    delete formModel[key as keyof typeof formModel];
  });
  // sort filter
  // get keys in order
  let formModelOriginalKeys = Object.keys(formModel);
  let formModelWithoutSortedKeys = formModelOriginalKeys.filter(
    (element) => columnOrder.indexOf(element) === -1
  );
  let formModelSortedKeys = [...columnOrder, ...formModelWithoutSortedKeys];
  // order object
  formModel = formModelSortedKeys.reduce((object: any, key: string) => {
    if (formModel[key]) object[key] = formModel[key];
    return object;
  }, {});

  onSubmit = onSubmitProps;
  const [advanced, setAdvanced] = useState(!allowAdvancedFilter);

  useEffect(() => {
    if (noCta) setOnChange(formValues);
  }, [formValues, setOnChange, noCta]);

  useEffect(
    () => {
      if (!isNil(initialFilterState) && !isNil(initialFilterValue)) {
        Object.keys(initialFilterState).forEach((key) => {
          const fieldName = initialFilterState[key];
          const fieldValue = initialFilterValue[key];
          if (Number(fieldValue) && fieldValue > 946681200000) {
            dispatch(changeForm(fieldName, [fieldValue, null]));
          } else {
            dispatch(changeForm(fieldName, fieldValue));
          }
        });
      }
      return () => {
        if (allowAdvancedFilter) {
          setAdvanced(false);
        }
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    if (allowAdvancedFilter && formValues?.advancedSearchFilter !== undefined) {
      setAdvanced(formValues.advancedSearchFilter);
    }
  }, [formValues?.advancedSearchFilter, allowAdvancedFilter]);

  return (
    <div className={classes.filterContainer}>
      <form
        onSubmit={(e) => {
          submitting(e, handleSubmit);
        }}
      >
        <div className="row">
          {Object.keys(formModel).map((item: any, i: number) => {
            const elementForm: any = formModel[item as keyof typeof formModel];
            const elementValueForm =
              formValues && formValues[item as keyof typeof formValues];

            const elementCompForm =
              components[elementForm.componentType as keyof typeof components];
            const elementLabelForm =
              `${elementForm.name}LabelForm` as keyof typeof messages;
            const elementLabel2Form =
              `${elementForm.name}2LabelForm` as keyof typeof messages;
            const elementListFilter =
              elementForm.listFilter &&
              listsFilter &&
              listsFilter[elementForm.listFilter];

            //condiction to show advanced form
            if (advancedFilter && allowAdvancedFilter) {
              const showFunc = (
                advancedElement: boolean,
                advanced: boolean
              ): boolean => {
                if (advancedElement && advanced) {
                  return true;
                }
                if (!advancedElement && !advanced) {
                  return true;
                }
                return false;
              };
              if ("advancedSearchFilter" === item) return null;
              const classAdvance: string = elementForm.advanced
                ? "col-sm-3 col-md-3 col-lg-3 col-xl-3 p-2 d-flex justify-content-between flex-wrap"
                : "col-sm-12 col-md-12 col-lg-12 col-xl-12 p-2 d-flex justify-content-between flex-wrap ";
              return (
                <React.Fragment key={"obj" + i}>
                  {showFunc(elementForm.advanced, advanced) && (
                    <div className={classAdvance}>
                      {
                        <Field
                          {...elementForm}
                          component={elementCompForm}
                          changeForm={(field: string, value: any) => {
                            changeForm(field, value);
                          }}
                          valueForm={elementValueForm}
                          selectType={
                            elementListFilter && elementListFilter.type
                          }
                          messages={messages}
                          checked={
                            elementForm.componentType === TOGGLE_FIELD &&
                            elementValueForm
                          }
                          label={
                            <FormattedMessage {...messages[elementLabelForm]} />
                          }
                          labelOne={
                            elementForm.componentType === TOGGLE_FIELD && (
                              <FormattedMessage
                                {...messages[elementLabelForm]}
                              />
                            )
                          }
                          labelTwo={
                            (elementForm.componentType === TOGGLE_FIELD ||
                              elementForm.componentType ===
                                DATA_RANGE_PICKER) && (
                              <FormattedMessage
                                {...messages[elementLabel2Form]}
                              />
                            )
                          }
                        >
                          {elementForm.componentType === SELECT_FIELD && (
                            <MenuItem value={""}> </MenuItem>
                          )}
                          {elementForm.componentType === SELECT_FIELD &&
                            elementListFilter &&
                            elementListFilter.list.map(
                              (res: any, i: number) => {
                                return (
                                  <MenuItem
                                    value={res.value}
                                    key={`${SELECT_FIELD}${elementForm.listFilter}${i}`}
                                  >
                                    <FormattedMessage
                                      {...messages[
                                        res.label as keyof typeof messages
                                      ]}
                                    />
                                  </MenuItem>
                                );
                              }
                            )}
                        </Field>
                      }
                    </div>
                  )}
                </React.Fragment>
              );
            }

            if (elementForm.name === "allFilter" && !allowAdvancedFilter)
              return null;

            return (
              <React.Fragment key={"obj" + i}>
                <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3 p-2 d-flex justify-content-between flex-wrap">
                  {!(elementForm.componentType === TOGGLE_FIELD) && (
                    <Field
                      {...elementForm}
                      component={elementCompForm}
                      changeForm={(field: string, value: any) => {
                        changeForm(field, value);
                      }}
                      valueForm={elementValueForm}
                      selectType={elementListFilter && elementListFilter.type}
                      messages={messages}
                      checked={
                        elementForm.componentType === TOGGLE_FIELD &&
                        elementValueForm
                      }
                      label={
                        <FormattedMessage {...messages[elementLabelForm]} />
                      }
                      labelOne={
                        elementForm.componentType === TOGGLE_FIELD && (
                          <FormattedMessage {...messages[elementLabelForm]} />
                        )
                      }
                      labelTwo={
                        (elementForm.componentType === TOGGLE_FIELD ||
                          elementForm.componentType === DATA_RANGE_PICKER) && (
                          <FormattedMessage {...messages[elementLabel2Form]} />
                        )
                      }
                    >
                      {elementForm.componentType === SELECT_FIELD && (
                        <MenuItem value={""}> </MenuItem>
                      )}
                      {elementForm.componentType === SELECT_FIELD &&
                        elementListFilter &&
                        elementListFilter.list.map((res: any, i: number) => {
                          return (
                            <MenuItem
                              value={res.value}
                              key={`${SELECT_FIELD}${elementForm.listFilter}${i}`}
                            >
                              <FormattedMessage
                                {...messages[
                                  res.label as keyof typeof messages
                                ]}
                              />
                            </MenuItem>
                          );
                        })}
                    </Field>
                  )}
                </div>
              </React.Fragment>
            );
          })}
        </div>
        {((advancedFilter && allowAdvancedFilter) || !noCta) && (
          <div className="row m-3">
            <div className="col-sm-2 col-md-2 col-lg-2 col-xl-2  d-flex justify-content-start">
              {advancedFilter && allowAdvancedFilter && (
                <Field
                  {...formModel[
                    "advancedSearchFilter" as keyof typeof formModel
                  ]}
                  checked={
                    formValues &&
                    formValues[
                      "advancedSearchFilter" as keyof typeof formValues
                    ]
                  }
                  labelOne={
                    <FormattedMessage
                      {...messages[
                        `advancedSearchFilterLabelForm` as keyof typeof messages
                      ]}
                    />
                  }
                  labelTwo={
                    <FormattedMessage
                      {...messages[
                        `advancedSearchFilter2LabelForm` as keyof typeof messages
                      ]}
                    />
                  }
                  changeForm={(key: string, val: boolean) => {
                    changeForm(key, val);
                    if (allowAdvancedFilter) {
                      setAdvanced(val);
                    }
                    if (
                      formValues &&
                      formValues[
                        "advancedSearchFilter" as keyof typeof formValues
                      ]
                    )
                      resetForm(form);
                  }}
                  component={ToggleField}
                />
              )}
            </div>
            {!noCta && (
              <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4 offset-sm-6 offset-md-6 offset-lg-6 d-flex justify-content-end">
                <Box sx={{ mx: 1 }} />
                <OutlinedButton
                  onClick={(e) => {
                    e.preventDefault();
                    if (allowAdvancedFilter) {
                      setAdvanced(false);
                    }
                    resetForm(form);
                  }}
                  fullColored={fullColored}
                  type="button"
                >
                  <FormattedMessage {...filterMessages.CTA_CANCEL} />
                </OutlinedButton>
                <Box sx={{ mx: 1 }} />
                <OutlinedButton type="submit" fullColored={fullColored}>
                  <FormattedMessage {...filterMessages.CTA_FILTER} />
                </OutlinedButton>
              </div>
            )}
          </div>
        )}
      </form>
    </div>
  );
};

const mapDispatchToProps: any = {
  resetForm: (form: string) => reset(form),
  changeForm: (field: string, value: any) => change(form, field, value),
};

const mapStateToProps: any = (state: any) => ({
  formValues: getFormValues(form)(state),
});

const withConnect: any = connect(mapStateToProps, mapDispatchToProps);

const createReduxForm = reduxForm<{}, IFilterProps>({
  form,
  onSubmit: (values: any, dispatch: any, props: any) => {
    let formValues = props.formValues;
    if (formValues) {
      Object.keys(formValues).forEach((key: any) => {
        if (typeof formValues[key] === "string") {
          formValues[key] = formValues[key].trim();
        }
      });
    }
    if (!props.allowAdvancedFilter) {
      // hardcode filter to advanced if it's not possible to use the simple one
      formValues = {
        advancedSearchFilter: true,
        ...formValues,
      };
    }
    formValues
      ? onSubmit(formValues, dispatch, props)
      : onSubmit(values, dispatch, props);
  },
});

export default withConnect(createReduxForm(Filter2));
